import { Outlet } from "react-router-dom";

const CareerDiscoveryLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default CareerDiscoveryLayout;
